import React from 'react';
import { Box, CssBaseline, styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';

import { isUsingCustomTheme, LoginContainer } from '@paragon/login-tools';
import { ParagonHeader } from '@paragon/material';
import { Notifier, NotifierDialog } from '@paragon/notification-tools';
import { ThemedLogo, UserDropdown } from '@paragon/themes';

import { startApp } from '../actions/startApp';
import { Content } from './Content';
import { DialogContainer } from './dialogs/DialogContainer';
import { useAppDispatch, useAppSelector } from './hooks';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent': { color: 'white' },
}));

export function RootComponent() {
  const dispatch = useAppDispatch();
  const usingCustomTheme = useAppSelector(isUsingCustomTheme);
  const renderHeaderText = (usingCustomTheme && `Production`) || 'Paragon Production';

  return (
    <>
      <CssBaseline />
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        maxSnack={1}
        Components={{
          default: StyledMaterialDesignContent,
          success: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
          warning: StyledMaterialDesignContent,
          info: StyledMaterialDesignContent,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            minHeight: '100vh',
            backgroundColor: 'canvas.main',
          }}
        >
          <Notifier />
          <NotifierDialog />
          <LoginContainer
            requirePermission="production-access"
            onLogIn={() => {
              dispatch(startApp());
            }}
            logoOverride={(usingCustomTheme && <ThemedLogo width={300} />) || undefined}
          >
            <ParagonHeader text={renderHeaderText} clientName="production">
              <UserDropdown hideThemeToggleButton />
            </ParagonHeader>

            <Content />

            <DialogContainer />
          </LoginContainer>
        </Box>
      </SnackbarProvider>
    </>
  );
}
